<template>
  <div @click="goToNotice" class="main-banner">
    <div class="title">
      고객 감사 <span class="text-primary"> 할증 요금 ZERO </span> 이벤트!
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goToNotice() {
      if (this.$route.path !== "/services/notices") {
        this.$router.push("/services/notices");
      }
    }
  }
};
</script>
<style scoped>
.main-banner {
  background-color: black;
  background-image: url("../../../assets/img/zero.png");
  background-repeat: no-repeat;
  background-size: 768px 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  color: var(--white);
  position: relative;
  padding: 0px 32px;
  cursor: pointer;
}
.title {
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
}
.title .text-primary {
  color: var(--primary-300);
}

@media all and (min-width: 1024px) {
  .title {
    font-size: 20px;
    line-height: 28px;
  }
}
</style>
